module.exports = ol.source.ImageStatic;